import B2B from "./b2b";
import B2C from "./b2c";
import B2CBigger from "./b2cBigger";
import Back from "./back";
import BathroomProducts from "./bathroom-products";
import BreadcrumbArrow from "./breadcrumb-arrow";
import BreadcrumbHome from "./breadcrumb-home";
import Bullet from "./bullet";
import Collect from "./collect";
import Compare from "./compare";
import ContactForm from "./contact-form";
import DownloadBook from "./download-book";
import ExternalLink from "./external-link";
import File from "./file";
import FileWithType from "./file-with-type";
import Flipbook from "./flipbook";
import Functions from "./functions";
import Gas from "./gas";
import HardDrive from "./hard-drive";
import Heating from "./heating";
import HovericonHoverImage from "./hovericonHoverImage";
import IDC from "./idc";
import IDCGbus from "./idc-gbus";
import IDCGbusPowersupply from "./idcgbus-powersupply";
import Industry from "./industry";
import InfoCircleFull from "./info-circle-full";
import InfoCircleFullBlue from "./info-circle-full-blue";
import InfoCircleOutline from "./info-circle-outline";
import Information from "./information";
import Inspirator from "./inspirator";
import InstallationSystems from "./installation-systems";
import LensZoomIn from "./lens-zoom-in";
import LensZoomOut from "./lens-zoom-out";
import MarkerHotelPin from "./marker-hotel-pin";
import MarkerPin from "./marker-pin";
import MoreActive from "./more-active";
import NavBathroomSystems from "./nav-bathroom-systems";
import NavCollections from "./nav-collections";
import NavDrainageSystems from "./nav-drainage-systems";
import NavInstallation from "./nav-installation";
import NavSupplySystems from "./nav-supply-systems";
import NavTools from "./nav-tools";
import New from "./new";
import Newsletter from "./newsletter";
import OpenBook from "./open-book";
import Options from "./options";
import PencilFilled from "./pencil-filled";
import Picture from "./picture";
import Reload from "./reload";
import SearchDocument from "./search-document";
import Security from "./security";
import ServiceChat from "./service-chat";
import ServiceFax from "./service-fax";
import ServicePinOutline from "./service-pin-outline";
import Shipbuilding from "./shipbuilding";
import Sprinkler from "./sprinkler";
import Tools from "./tools";
import UnderfloorHeating from "./underfloor-heating";
import Watchlist from "./watchlist";
import WatchlistAdd from "./watchlistAdd";
import WatchlistAdded from "./watchlistAdded";
import Water from "./water";
export const deprecatedIcons = {
    b2b: B2B,
    b2c: B2C,
    b2cbigger: B2CBigger,
    back: Back,
    bathroomproducts: BathroomProducts,
    breadcrumbarrow: BreadcrumbArrow,
    breadcrumbhome: BreadcrumbHome,
    bullet: Bullet,
    collect: Collect,
    compare: Compare,
    contactform: ContactForm,
    downloadbook: DownloadBook,
    externallink: ExternalLink,
    file: File,
    filewithtype: FileWithType,
    flipbook: Flipbook,
    functions: Functions,
    gas: Gas,
    harddrive: HardDrive,
    heating: Heating,
    hovericonhoverimage: HovericonHoverImage,
    idc: IDC,
    idcgbus: IDCGbus,
    idcgbuspowersupply: IDCGbusPowersupply,
    industry: Industry,
    infocirclefull: InfoCircleFull,
    infocirclefullblue: InfoCircleFullBlue,
    infocircleoutline: InfoCircleOutline,
    information: Information,
    inspirator: Inspirator,
    installationsystems: InstallationSystems,
    lenszoomin: LensZoomIn,
    lenszoomout: LensZoomOut,
    markerhotelpin: MarkerHotelPin,
    markerpin: MarkerPin,
    moreactive: MoreActive,
    navbathroomsystems: NavBathroomSystems,
    navcollections: NavCollections,
    navdrainagesystems: NavDrainageSystems,
    navinstallation: NavInstallation,
    navsupplysystems: NavSupplySystems,
    navtools: NavTools,
    new: New,
    newsletter: Newsletter,
    openbook: OpenBook,
    options: Options,
    pencilfilled: PencilFilled,
    picture: Picture,
    reload: Reload,
    searchdocument: SearchDocument,
    security: Security,
    servicechat: ServiceChat,
    servicefax: ServiceFax,
    servicepinoutline: ServicePinOutline,
    shipbuilding: Shipbuilding,
    sprinkler: Sprinkler,
    tools: Tools,
    underfloorheating: UnderfloorHeating,
    watchlist: Watchlist,
    watchlistadd: WatchlistAdd,
    watchlistadded: WatchlistAdded,
    water: Water,
};
